import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import s1 from '../../assets/img/services/1.png';
import s2 from '../../assets/img/services/2.png';
import s3 from '../../assets/img/services/3.png';
import s4 from '../../assets/img/services/4.png';
import s5 from '../../assets/img/services/5.png';
import s6 from '../../assets/img/services/6.png';
import s7 from '../../assets/img/services/7.png';
import s8 from '../../assets/img/services/8.png';
import s9 from '../../assets/img/services/9.png';

const ServicesSection = ({
  title = <><span className="text-primary">Our</span> Scan to BIM Deliverables</>,
  subtitle = "With a team of 100+  scan to BIM modelers, architects and engineers, we offer efficient architectural Point Cloud to BIM and CAD solutions, specializing in 3D Scan to BIM and 3D point cloud to CAD services for Surveyors, Architects, and Engineers."
}) => {
  const services = [
    { title: "BIM Services", img: s1, desc: "Scan to BIM Services company offers premier BIM outsourcing services, specializing in Revit BIM, BIM Modeling, Point Cloud to BIM, 3D, 4D & 5D BIM Modeling." },
    { title: "Point Cloud to BIM", img: s2, desc: "Scan to BIM company Converting laser scan data into precise 2D AutoCAD drawings and floor plans for architects and engineers." },
    { title: "As built BIM Drawing", img: s3, desc: "Scan to bim services company creates reliable drawings as-built with respect to the existing condition of the structure for later use." },
    { title: "MEP BIM Services", img: s4, desc: "We offer MEP BIM services for mechanical, electrical, and plumbing systems, ensuring coordinated and clash-free designs for construction projects." },
    { title: "Scan to BIM Services", img: s5, desc: "Scan to bim services company offers the best Point Cloud to BIM Modeling and Scan to BIM Modeling services at the best price in the USA." },
    { title: "Laser Scan to BIM", img: s6, desc: "Our 3D BIM modeling services create detailed, data-rich virtual models of buildings, helping to visualize and coordinate projects before construction." },
    { title: "Scan to BIM Services California", img: s7, desc: "Scan to BIM Service company transform point cloud and laser scan data into accurate, editable 2D and 3D CAD models for renovation and as-built documentation projects." },
    { title: "Shop Drawing Services", img: s8, desc: "Scan to BIM Service Company offers precise shop drawings, detailing fabrication and assembly for seamless construction and project accuracy." },
    { title: "CAD Drafting Services", img: s9, desc: "Scan to BIM Service Company offers precise CAD drafting services, creating detailed technical drawings and plans for any architectural or engineering project." }
  ];

  return (
    <section className="services-section">
      <div className="services-header">
        <h2 className="services-title">
          {title}
        </h2>
        <p className="services-subtitle">
          {subtitle}
        </p>
      </div>

      <div className="slider-marquee">
        <div className="slider-track">
          {[...Array(4)].map((_, setIndex) => (
            <React.Fragment key={setIndex}>
              {services.map((service, index) => (
                <div key={`s${setIndex}-${index}`} className="service-card">
                  <div className="service-card-header">{service.title}</div>
                  <div className="service-card-body">
                    <p className="service-card-desc">
                      {service.desc}
                    </p>
                    <button className="service-btn">
                      View More <ArrowUpRight size={14} />
                    </button>
                  </div>
                  <div className="service-card-img-wrapper">
                    <img
                      src={service.img.src || service.img}
                      alt={service.title}
                      className="service-card-img"
                    />
                  </div>
                </div>
              ))}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
